import { render, staticRenderFns } from "./index_router.vue?vue&type=template&id=60902795&scoped=true"
import script from "./index_router.vue?vue&type=script&lang=js"
export * from "./index_router.vue?vue&type=script&lang=js"
import style0 from "./index_router.vue?vue&type=style&index=0&id=60902795&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60902795",
  null
  
)

export default component.exports